module.exports = __webpack_public_path__ + "img/gangwei.242fb089.png";